import React, { useState } from 'react';
import { connect } from 'react-redux';
import { postAPI, reinitialiseAPI } from 'store/apiReducer';
import PropTypes from 'prop-types';
import { useHistory, useLocation } from 'react-router-dom';
import { FormProvider, useForm } from 'react-hook-form';
import { ButtonGroup, Button, Container, Row, Col, SegmentLoader } from '@si-armes/dsfr-react';
import {
    API_AJOUTER_ADRESSE_SECONDAIRE,
    CONTEXT_API_AJOUTER_ADRESSE_SECONDAIRE,
    API_POST_VERIFIER_BAN,
    CONTEXT_POST_VERIFIER_BAN,
} from 'constants/apiUrls.constants';
import usagerClientReducer from 'store/usagerReducer';
import FormulaireAdresseSimple from 'components/form/formulaireAdresse/FormulaireAdresseSimple';
import ModalBan from 'components/modalBan/ModalBan';
import RoutesEcranGestion from '../gestion/routes';
import { getPath } from '../../../../utils/router';
import InfoChampsObligatoire from '../../../../components/form/infoObligatoire/InfoChampsObligatoire';

const AjouterAdresseSecondaire = ({
    postApi,
    reinitialiseApi,
    dataBan,
    isLoadingBan,
    isLoadingAjoutAdresse,
}) => {
    const history = useHistory();
    const location = useLocation();
    const uniquidPersonnePhysique = location.state?.uniquidPersonnePhysique;
    const hookForm = useForm({ mode: 'onChange' });
    const { handleSubmit } = hookForm;
    const [dataToSubmit, setDataToSubmit] = useState(null);
    const [ouvrirModalBan, setOuvrirModalBan] = useState(false);

    const verifierBan = (data) => {
        const adresseAverifier = {
            numeroVoie: data.numeroDeVoie,
            libelleVoie: data.typeEtNomDeVoie,
            codePostal: data.codePostal,
            ville: data.ville,
            extension: data.extension,
            lieuDit: data.lieuDit,
        };

        reinitialiseApi(CONTEXT_POST_VERIFIER_BAN);
        postApi(
            usagerClientReducer,
            API_POST_VERIFIER_BAN,
            adresseAverifier,
            CONTEXT_POST_VERIFIER_BAN,
        );
        setDataToSubmit(data);
        setOuvrirModalBan(true);
    };

    const ajoutAdresse = (dataToSend) => {
        reinitialiseApi(CONTEXT_API_AJOUTER_ADRESSE_SECONDAIRE);
        postApi(
            usagerClientReducer,
            API_AJOUTER_ADRESSE_SECONDAIRE,
            dataToSend,
            CONTEXT_API_AJOUTER_ADRESSE_SECONDAIRE,
        );
    };

    const redirectToEcranGestion = () => {
        history.push(getPath(RoutesEcranGestion));
    };

    const onSubmit = async (dataToSend) => {
        const adresseAAjouter = {
            ...dataToSend,
            uniquidPersonnePhysique,
        };
        ajoutAdresse(adresseAAjouter);
        redirectToEcranGestion();
    };

    const fermerModal = () => {
        setOuvrirModalBan(false);
        reinitialiseApi(CONTEXT_POST_VERIFIER_BAN);
    };

    const conserver = () => {
        fermerModal();
        onSubmit({ ...dataToSubmit, hasVerificationBan: false });
    };

    const remplacer = () => {
        fermerModal();
        onSubmit({
            ...dataToSubmit,
            numeroDeVoie: dataBan.numeroVoie,
            typeEtNomDeVoie: dataBan.libelleVoie,
            extension: dataBan.extension,
            lieuDit: dataBan.lieuDit,
            codePostal: dataBan.codePostal,
            ville: dataBan.ville,
            hasVerificationBan: true,
        });
    };

    return (
        <Container>
            <Row>
                <Col col={12}>
                    <h1>Ajouter une adresse secondaire</h1>
                </Col>
            </Row>
            <Row>
                <Col col={12}>
                    <InfoChampsObligatoire />
                </Col>
            </Row>
            <SegmentLoader isLoading={isLoadingAjoutAdresse}>
                <FormProvider {...hookForm}>
                    <form onSubmit={handleSubmit(verifierBan)}>
                        <FormulaireAdresseSimple />
                        <Row className="margin-top-lg">
                            <Col col={12}>
                                <ButtonGroup align="right" inline>
                                    <Button
                                        name="etapePrecedente"
                                        variant="secondary"
                                        onClick={redirectToEcranGestion}
                                    >
                                        Retour
                                    </Button>
                                    <Button name="validerAdresse" variant="primary" type="submit">
                                        Valider
                                    </Button>
                                </ButtonGroup>
                            </Col>
                        </Row>
                    </form>
                </FormProvider>
            </SegmentLoader>
            {ouvrirModalBan && (
                <ModalBan
                    residence="secondaire"
                    fermerModal={fermerModal}
                    data={dataBan}
                    isLoading={isLoadingBan}
                    remplacer={remplacer}
                    conserver={conserver}
                />
            )}
        </Container>
    );
};

AjouterAdresseSecondaire.propTypes = {
    postApi: PropTypes.func.isRequired,
    reinitialiseApi: PropTypes.func.isRequired,
    isLoadingBan: PropTypes.bool,
    dataBan: PropTypes.any,
    isLoadingAjoutAdresse: PropTypes.bool,
};

export default connect(
    (state) => {
        const { isLoading: isLoadingAjoutAdresse } = state.monCompte.ajoutAdresseSecondaire;
        const { isLoading: isLoadingBan, data: dataBan } = state.adresseVerificationBAN.verifier;
        return {
            isLoadingBan,
            dataBan,
            isLoadingAjoutAdresse,
        };
    },
    {
        postApi: postAPI,
        reinitialiseApi: reinitialiseAPI,
    },
)(AjouterAdresseSecondaire);
